import AddEditHorseModal from './AddEditHorseModal';

export default AddEditHorseModal;
